export default __webpack_public_path__ + "static/waitingThoughtSinging-38ee4204d5e4963f580db7ade6e79dfa.svg";